import React from "react";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ProfileCard from "./ProfileCard";
import { roleLabels } from "./profileModel";

function InvitationRow({ invitation, onAccept, onDecline }) {
  return (
    <div className="pf-lr pending" data-testid={`profile-invitation-${invitation.id}`}>
      <span className="ic"><SchoolOutlinedIcon sx={{ fontSize: 18 }} /></span>
      <div>
        <b>{invitation.tenantName || invitation.tenantId}</b>
        <small>Invited as {roleLabels([invitation.role])[0] || invitation.role} by {invitation.invitedByName || "a coordinator"}</small>
      </div>
      <div className="r">
        <button type="button" className="pf-btn pf-btn-p pf-btn-sm" onClick={() => onAccept(invitation.id)}>Accept</button>
        <button type="button" className="pf-btn pf-btn-g pf-btn-sm" onClick={() => onDecline(invitation.id)}>Decline</button>
      </div>
    </div>
  );
}

/** Only centers where the user holds a role, plus invitations addressed to them. */
export default function CentersCard({ tenantRoles, tenantNames, invitations, onAccept, onDecline }) {
  const memberIds = Object.keys(tenantRoles || {});
  return (
    <ProfileCard id="centers" title="Training centers" subtitle="Centers you belong to and your role at each.">
      {invitations.map((inv) => (
        <InvitationRow key={inv.id} invitation={inv} onAccept={onAccept} onDecline={onDecline} />
      ))}
      {memberIds.length === 0 && invitations.length === 0 ? (
        <div className="pf-empty">You don't belong to a training center yet.</div>
      ) : (
        memberIds.map((id) => (
          <div className="pf-lr" key={id} data-testid={`profile-center-${id}`}>
            <span className="ic"><SchoolOutlinedIcon sx={{ fontSize: 18 }} /></span>
            <div>
              <b>{tenantNames?.[id] || id}</b>
              <small>{roleLabels(tenantRoles[id]).join(" · ")}</small>
            </div>
            <div className="r">
              <span className="pf-tag ok"><i />Member</span>
            </div>
          </div>
        ))
      )}
    </ProfileCard>
  );
}
